<template>
	<div class="childDiv1 flex justify-center items-center" id="page6" ref="mainEl" page="6">
		<!-- <img alt="" src="images/1x_images/page6.png" srcset="images/2x_images/page6.png 2x" ref="part1El" /> -->
		<img class="absolute center top-[450px]" alt="" src="images/1x_images/section1/page6/page6-title.png" srcset="images/2x_images/section1/page6/page6-title.png 2x" ref="part1El" />
		<video ref="videoEl" loop muted>
			<source type="video/mp4" />
			Your browser does not support HTML video.
		</video>
	</div>
</template>

<script>
/* eslint-disable */
import gsap from "gsap";

export default {
	name: "page-1",
	data() {
		return {
			showModal: "",
			videoInterval: null,
			loaded: false,
		};
	},
	methods: {
		start() {},
		stop() {},
		loadVideo() {
			fetch("/videos/Video-Lab.mp4")
				.then((res) => {
					console.log("res2", res);
					if (this.loaded) return;
					const video = this.$refs.videoEl;
					video.src = "/videos/Video-Lab.mp4";
					video.load();
				})
				.catch((e) => {
					console.log("error2", e);
				});
		},
		initVideo() {
			const video = this.$refs.videoEl;
			// prettier-ignore
			video.addEventListener("loadeddata", () => {
				console.log("video play");
				this.loaded = true;
				clearInterval(this.videoInterval);
				video.play();
				gsap.set(video, { autoAlpha: 1 });
			}, { once: true });
		},
		setLoadVideo() {
			this.videoInterval = setInterval(() => {
				this.loadVideo();
			}, 500);
			this.initVideo();
		},
	},
	mounted() {
		gsap.set(this.$refs.videoEl, { autoAlpha: 0 });
	},
};
</script>

<style scoped>
video {
	height: 100%;
	max-width: none;
}
</style>
